import React, { useCallback, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineFileSearch } from "react-icons/ai";
import { SessionContext } from "../../../context/sessionContext";
import { getStudentList } from "../../../actions/school_user/StudentRegistration";
import {
  CustomModal,
  CustomModalBody,
  CustomModalHeader,
} from "../../CommonComponent/modelComponent";
import { convertDate } from "../../CommonComponent/DateFormatUtil";

const StudentList = (props) => {
  // this list contains all the student list with all the details
  const { FeesDetails, setstudent_uid } = props;
  const token = localStorage.getItem("token");
  const school_user = JSON.parse(localStorage.getItem("school_user"));
  const { id, user_type, name, user_detail } = school_user;
  let s_id = user_detail?.fk_school_id;
  const { Session } = useContext(SessionContext);
  let session_id = Session || sessionStorage.getItem("SessionId");
  const { studentdata } = useSelector((state) => state.studentRegistration);
  const [CurrentPage, setCurrentPage] = useState(1);
  const [Page, setPage] = useState(1);
  const resultPerPage = 10;
  const [searchQuery, setSearchQuery] = useState("");
  const [idQuery, setIdQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [noResultsMessage, setNoResultsMessage] = useState("");
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();
  const toggle = () => {
    if (!modal) {
      setCurrentPage(1);
      if (studentdata?.payload) {
        setSearchResults(studentdata.payload);
      }
    } else {
      setSearchResults([]);
      setNoResultsMessage("");
    }
    setModal(!modal);
  };

  const handleInputChangeSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  };
  const handleIdInputChange = (e) => {
    const query = e.target.value;
    setIdQuery(query);
  };
  const handleSearch = () => {
    const filteredResults = studentdata?.payload?.filter(
      (item) =>
        item.std_name?.toLowerCase().includes(searchQuery?.toLowerCase()) &&
        item.student_code?.toString().includes(idQuery)
    );
    setSearchResults(filteredResults);
    setSearchQuery("");
    setIdQuery("");
    if (filteredResults?.length === 0) {
      setNoResultsMessage("No results found.");
    } else {
      setNoResultsMessage("");
    }
  };
  const dispatchGetStudentList = useCallback(
    (token, body) => {
      return dispatch(getStudentList(token, body));
    },
    [dispatch]
  );
  useEffect(() => {
    if (!modal) return;
    let body = {
      fk_academic: session_id,
      school_id: s_id,
      student_name: searchQuery,
      student_code: idQuery,
      page: CurrentPage,
      status_type: "Admitted",
    };
    if (token) {
      dispatchGetStudentList(token, body).then((res) => {
        if (res) setPage(res.totalRecordCount);
      });
    }
  }, [
    dispatchGetStudentList,
    token,
    session_id,
    CurrentPage,
    idQuery,
    searchQuery,
    modal,
  ]);

  useEffect(() => {
    setSearchResults(studentdata?.payload);
  }, [studentdata]);

  const handleStudentEdit = (data) => {
    setstudent_uid(data?.student_code);
    setModal(!modal);
    FeesDetails();
  };
  
  return (
    <>
      <span className="" type="button" onClick={toggle}>
        <AiOutlineFileSearch style={{ fontSize: "1.5rem" }} />
      </span>
      <CustomModal
        modal={modal}
        toggle={toggle}
        activePage={CurrentPage}
        itemsCountPerPage={resultPerPage}
        totalItemsCount={Page}
        onChange={(e) => setCurrentPage(e)}
        

      >
        <CustomModalHeader toggle={toggle}>
          <div className=" row">
            <div className="col-lg-5 col-md-5 col-sm-5 my-1">
              <input
                name="code"
                type="number"
                className="form-control"
                placeholder="Student code"
                value={idQuery}
                onChange={handleIdInputChange}
                autoComplete="off"
              />
            </div>
            <div className="col-lg-5 col-md-5 col-sm-5 my-1 ">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Student Name"
                value={searchQuery}
                onChange={handleInputChangeSearch}
                autoComplete="off"
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 my-1 text-right">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={handleSearch}
              >
                Search
              </button>
            </div>
          </div>
        </CustomModalHeader>
        <CustomModalBody noResultsMessage={noResultsMessage}>
          <thead>
            <tr className="text-center text-nowrap">
              <th>Registration Date</th>
              <th>Student Code</th>
              <th>Student Name</th>
              <th>Gender</th>
              <th>DOB</th>
              <th>Category</th>
              <th>Caste</th>
              <th>Sub Caste</th>
              <th>Student Status</th>
              <th>Enrollment No</th>
              <th>Academic Session</th>
            </tr>
          </thead>
          <tbody>
            {searchResults?.map((stu, index) => (
              <tr
                key={index}
                className="text-center"
                onClick={() => handleStudentEdit(stu)}
                style={{ cursor: "pointer" }}
              >
                <td>{convertDate(stu.registration_date)}</td>
                <td>{stu.student_code}</td>
                <td className="text-left">{stu.std_name}</td>
                <td>{stu.gender}</td>
                <td>{convertDate(stu.date_of_birth)}</td>
                <td>{stu.fk_category_name}</td>
                <td>{stu.fk_caste_name}</td>
                <td>{stu.sub_caste}</td>
                <td>{stu.student_status}</td>
                <td></td>
                <td>{stu?.academic_year}</td>
              </tr>
            ))}
          </tbody>
        </CustomModalBody>
      </CustomModal>
    </>
  );
};

export default StudentList;
